export default {
    en: {
        LIBRARY_ENTRIES_DIALOG_TITLE: "Create a Challenge",
        LIBRARY_ENTRIES_DIALOG_CONFIRM: "Next",
        LIBRARY_ENTRIES_DIALOG_SPLASH_SCREEN_TEXT: "Please select a challenge from the list.",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_DESCRIPTION: "Description:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_ARTIFACTS: "Artifacts:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_CATEGORY: "Category:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_POINTS: "Points:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_DIFFICULTY: "Difficulty:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_VISIBILITY: "Visibility:",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_ARTIFACT_ANNOUNCEMENT_PRELUDE: "Additional Entry Details. ",
        LIBRARY_ENTRIES_DIALOG_PREVIEW_ARTIFACT_ANNOUNCEMENT_PART: "{type} - {name}",
        LIBRARY_ENTRIES_DIALOG_LIST_LABEL: "Library Entries",
        LIBRARY_ENTRIES_DIALOG_LIST_NO_SELECTION_ERROR: "At least one Library Entry is required.",
    }
};
